import React, { Component } from 'react';

import Link from '../Link/Link';
import { primary_s25_l90, primary_s20_l87 } from '../lib/colors';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

import './Pager.scss';

class Pager extends Component {
  render() {
    let {
      location,
      page,
      totalPages,
      sort,
      primaryColor,
      uiVariantButton,
      isNew = false,
    } = this.props;
    page = parseInt(page);

    const isFirstPage = !page || page === 1;
    const isLastPage = page === totalPages;

    const previousLocation = {
      pathname: location.pathname,
      query: {
        page: isFirstPage ? 1 : page - 1,
        sort,
      },
    };

    const nextLocation = {
      pathname: location.pathname,
      query: {
        page: isLastPage ? totalPages : page + 1,
        sort,
      },
    };

    return (
      <div className={`pages ${isNew ? 'new' : ''}`}>
        <Link
          to={previousLocation}
          aria-label="Pagina precedente"
          className={`prev-page ${isFirstPage ? 'disabled' : ''}`}
          style={{
            color: `${isFirstPage ? primary_s25_l90(primaryColor) : '#4f4f4f'}`,
            backgroundColor: `${
              isNew && isFirstPage
                ? primary_s20_l87(primaryColor)
                : primaryColor
            }`,
            borderRadius: `${
              isNew && uiVariantButton === '1'
                ? '12px'
                : isNew && uiVariantButton === '3'
                ? '6px'
                : 0
            }`,
          }}
        >
          <FiChevronLeft />
        </Link>

        <span className="current-page">{page}</span>

        <Link
          to={nextLocation}
          aria-label="Pagina successiva"
          className={`next-page ${isLastPage ? 'disabled' : ''}`}
          style={{
            color: `${isLastPage ? primary_s25_l90(primaryColor) : '#4f4f4f'}`,
            backgroundColor: `${
              isNew && isLastPage ? primary_s20_l87(primaryColor) : primaryColor
            }`,
            borderRadius: `${
              isNew && uiVariantButton === '1'
                ? '12px'
                : isNew && uiVariantButton === '3'
                ? '6px'
                : 0
            }`,
          }}
        >
          <FiChevronRight />
        </Link>

        <span className="of">di</span>
        <span className="total-pages">{totalPages}</span>
      </div>
    );
  }
}

export default Pager;
